import React, {Component, createRef} from 'react'
import styles from './FJPreviewTool.module.less';
import classNames from 'classnames';
import FJUtil from "fj-components/util/FJUtil";
import FJButtonNormalIcon from "./FJButtonNormalIcon";
import FJButtonBackward from "./FJButtonBackward";
import FJButtonForward from "./FJButtonForward";

import FJSliderPlay from "./FJSliderPlay";
import playSvg from './icon/play.svg';
import fastForwardSvg from './icon/fastForward.svg';
import fastRewindSvg from './icon/fastRewind.svg';
import stopSvg from './icon/stop.svg';
import PropTypes from 'prop-types';

class FJPreviewTool extends Component {

  /**
   * @description 开始触发进度条
   * @param value 10.25
   * @param progress 0.1025
   * @private
   */
  _onBeforeChange = (value, progress) => {
    this.props.seek('start', progress);
  };

  /**
   * @description 触发进度条
   * @param value
   * @param progress
   * @private
   */
  _onChange = (value, progress) => {
    this.props.seek('change', progress);
  };

  /**
   * @description 触发进度条end
   * @param value
   * @param progress
   * @private
   */
  _onAfterChange = (value, progress) => {
    this.props.seek('end', progress);
  };

  /**
   * @description 按住快进或者快退
   * @param type 1快退 2快进
   * @private
   */
  _onMouseDown = (type) => {
    this._handleClick(type, 'start');
    this._handleClick(type, 'change');
    this._clearTimer();
    this._timeOut = setTimeout(() => {
      this._timeInterval = setInterval(() => {
        this._handleClick(type, 'change');
      }, 100);
    }, 400)
  };

  /**
   * @description 鼠标按下后抬起 快进或者快退
   * @param type 1快退 2快进
   * @private
   */
  _onMouseUp = (type) => {
    this._clearTimer();
    this._timeInterval = null;
    this._timeOut = null;
    this._handleClick(type, 'end');
  };

  /**
   * @description 清除定时器
   * @private
   */
  _clearTimer = () => {
    if (this._timeInterval) {
      clearInterval(this._timeInterval);
    }
    if (this._timeOut) {
      clearTimeout(this._timeOut);
    }
  };

  /**
   * @description 条用快进快退
   * @param type 1快退 2快进
   * @param step
   * @private
   */
  _handleClick = (type, step) => {
    if (type === 1) {
      this.props.fastRewind(step);
    } else if (type === 2) {
      this.props.fastForward(step);
    }
  };

  _onLeftPressUp = () => {
    this._onMouseUp(1);
    FJUtil.removeEvent(document, 'mouseup', this._onLeftPressUp);
  };

  _onRightPressUp = () => {
    this._onMouseUp(2);
    FJUtil.removeEvent(document, 'mouseup', this._onRightPressUp);
  };

  render() {
    let {
      isPlaying,
      play,
      stop,
      duration,
      classes,
      config
    } = this.props;

    let cn = classNames(styles.tool_box, classes.toolBoxClassName);
    let btnClass = classNames(classes.btnClassName);

    let _sliderDisabled = duration === 0;
    let _playDisabled = duration === 0;

    let {
      playIcon,
      fastForwardIcon,
      fastRewindIcon,
      stopIcon
    } = config;

    return (
      <div className={cn}>
        <div className={styles.video_tool}>
          <FJButtonBackward icon={fastRewindIcon ? fastRewindIcon : fastRewindSvg} className={btnClass} onMouseDown={() => {
            this._onMouseDown(1);
            FJUtil.addEvent(document, 'mouseup', this._onLeftPressUp);
          }} />
          {
            isPlaying === 0 ?
              <div className={classNames(styles.playClass, {[styles.hide]: duration === 0})}>
                <FJButtonNormalIcon icon={playIcon ? playIcon : playSvg} disabled={_playDisabled} onClick={play} className={btnClass}/>
              </div> :
              <div className={styles.stopClass}>
                <FJButtonNormalIcon icon={stopIcon ? stopIcon : stopSvg} disabled={_playDisabled} onClick={stop} className={btnClass}/>
              </div>
          }
          <FJButtonForward icon={fastForwardIcon ? fastForwardIcon : fastForwardSvg} className={btnClass} onMouseDown={() => {
            this._onMouseDown(2);
            FJUtil.addEvent(document, 'mouseup', this._onRightPressUp);
          }} />
        </div>
        <div className={styles.slider_box}>
          <FJSliderPlay onBeforeChange={this._onBeforeChange}
                        onChange={this._onChange}
                        onAfterChange={this._onAfterChange}
                        disabled={_sliderDisabled}
                        classes={classes.slider}
          />
        </div>
      </div>
    )
  }
}

FJPreviewTool.propTypes = {
  classes: PropTypes.object,
};

FJPreviewTool.defaultProps = {
  classes: {
    toolBoxClassName: '',
    slider: {
      sliderBoxClassName: '',
      railClassName: '',
      trackClassName: '',
      handleClassName: '',
      disableClassName: ''
    },
    btnClassName: ''
  },
  config: {
    playIcon: null,
    fastForwardIcon: null,
    fastRewindIcon: null,
    stopIcon: null
  }
};

export default FJPreviewTool;
